/* ====================================================================
   NANOGROW × ODORMAX — Global Theme JS
   Cart drawer, mobile nav toggle, qty helpers (global)
   ==================================================================== */
(function () {
  'use strict';

  /* ── Cart Drawer ─────────────────────────────────────────────── */
  var drawer = document.getElementById('cart-drawer');
  var cartBadges = document.querySelectorAll('[data-cart-count]');

  function openCart() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-open');
  }
  function closeCart() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-open');
  }

  // Open via any element with [data-cart-open] OR link to /cart
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-cart-open]');
    if (opener) {
      e.preventDefault();
      fetchCart().then(renderDrawer).then(openCart);
      return;
    }
    var closer = e.target.closest('[data-cart-close]');
    if (closer) {
      e.preventDefault();
      closeCart();
      return;
    }
  });

  // ESC to close
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.getAttribute('aria-hidden') === 'false') {
      closeCart();
    }
  });

  /* ── Cart API helpers ────────────────────────────────────────── */
  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .catch(function () { return null; });
  }

  function updateCartItem(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); });
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function renderDrawer(cart) {
    if (!cart || !drawer) return cart;
    var body = document.getElementById('cart-drawer-body');
    var countEl = document.getElementById('cart-drawer-count');
    if (countEl) countEl.textContent = cart.item_count;

    cartBadges.forEach(function (el) { el.textContent = cart.item_count; });

    if (!body) return cart;

    if (cart.item_count === 0) {
      body.innerHTML =
        '<div class="cart-drawer__empty">' +
          '<div class="cart-drawer__empty-icon">' +
            '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 8C8 10 5 16 5 20c6 0 12-3 14-12-1 0-4 0-7 2-3-2-5-4-5-4z"/></svg>' +
          '</div>' +
          '<p class="cart-drawer__empty-text">Your cart is empty</p>' +
          '<a href="/collections/all" class="btn btn--primary" data-cart-close>Continue Shopping</a>' +
        '</div>';
      var footer = drawer.querySelector('.cart-drawer__footer');
      if (footer) footer.remove();
      return cart;
    }

    var html = '<ul class="cart-drawer__items">';
    cart.items.forEach(function (item) {
      html +=
        '<li class="cart-item" data-cart-item-key="' + item.key + '">' +
          '<a href="' + item.url + '" class="cart-item__image-wrap" tabindex="-1">' +
            (item.image ? '<img src="' + item.image + '" alt="" class="cart-item__image" loading="lazy" width="80" height="80">' : '') +
          '</a>' +
          '<div class="cart-item__info">' +
            '<a href="' + item.url + '" class="cart-item__title">' + item.product_title + '</a>' +
            (item.variant_title && item.variant_title !== 'Default Title' ? '<p class="cart-item__variant">' + item.variant_title + '</p>' : '') +
            '<p class="cart-item__price">' + formatMoney(item.final_line_price) + '</p>' +
            '<div class="cart-item__actions">' +
              '<div class="cart-item__qty">' +
                '<button type="button" class="cart-item__qty-btn" data-cart-qty="minus" data-key="' + item.key + '" aria-label="Decrease quantity">−</button>' +
                '<input type="number" class="cart-item__qty-input" value="' + item.quantity + '" min="0" data-key="' + item.key + '" aria-label="Quantity">' +
                '<button type="button" class="cart-item__qty-btn" data-cart-qty="plus" data-key="' + item.key + '" aria-label="Increase quantity">+</button>' +
              '</div>' +
              '<button type="button" class="cart-item__remove" data-cart-remove data-key="' + item.key + '" aria-label="Remove item">Remove</button>' +
            '</div>' +
          '</div>' +
        '</li>';
    });
    html += '</ul>';
    body.innerHTML = html;

    // Ensure footer exists
    var existingFooter = drawer.querySelector('.cart-drawer__footer');
    var footerHTML =
      '<div class="cart-drawer__subtotal"><span>Subtotal</span><span class="cart-drawer__subtotal-amount">' + formatMoney(cart.total_price) + '</span></div>' +
      '<p class="cart-drawer__note">Shipping & taxes calculated at checkout</p>' +
      '<a href="/checkout" class="btn btn--primary btn--lg cart-drawer__checkout">Checkout · ' + formatMoney(cart.total_price) + '</a>' +
      '<a href="/cart" class="cart-drawer__view-cart" data-cart-close>View full cart</a>';
    if (existingFooter) {
      existingFooter.innerHTML = footerHTML;
    } else {
      var panel = drawer.querySelector('.cart-drawer__panel');
      var newFooter = document.createElement('footer');
      newFooter.className = 'cart-drawer__footer';
      newFooter.innerHTML = footerHTML;
      panel.appendChild(newFooter);
    }
    // Notify the gift/progress script to re-sync
    document.dispatchEvent(new CustomEvent('cart:updated'));
    return cart;
  }

  // Re-render drawer when cart:refresh fires (e.g. after auto-gift add/remove)
  document.addEventListener('cart:refresh', function () {
    fetchCart().then(renderDrawer);
  });

  // Qty change + remove delegation
  if (drawer) {
    drawer.addEventListener('click', function (e) {
      var qtyBtn = e.target.closest('[data-cart-qty]');
      var removeBtn = e.target.closest('[data-cart-remove]');
      if (qtyBtn) {
        var key = qtyBtn.getAttribute('data-key');
        var input = drawer.querySelector('.cart-item__qty-input[data-key="' + key + '"]');
        if (!input) return;
        var current = parseInt(input.value, 10) || 0;
        var next = qtyBtn.getAttribute('data-cart-qty') === 'plus' ? current + 1 : Math.max(0, current - 1);
        input.value = next;
        updateCartItem(key, next).then(renderDrawer);
      }
      if (removeBtn) {
        var rKey = removeBtn.getAttribute('data-key');
        updateCartItem(rKey, 0).then(renderDrawer);
      }
    });
    drawer.addEventListener('change', function (e) {
      var input = e.target.closest('.cart-item__qty-input');
      if (!input) return;
      var key = input.getAttribute('data-key');
      var qty = Math.max(0, parseInt(input.value, 10) || 0);
      updateCartItem(key, qty).then(renderDrawer);
    });
  }

  // Intercept add-to-cart forms to refresh drawer
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[action^="/cart/add"]')) return;
    if (e.submitter && e.submitter.hasAttribute('data-buy-now')) return;
    e.preventDefault();
    var data = new FormData(form);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: data
    })
      .then(function (r) { return r.json(); })
      .then(function () { return fetchCart(); })
      .then(renderDrawer)
      .then(openCart)
      .catch(function () { form.submit(); });
  });

  /* ── Variant selected state (product pages) ─────────────────── */
  document.querySelectorAll('[data-variant-group]').forEach(function (group) {
    group.addEventListener('change', function (e) {
      if (e.target.name !== 'id') return;
      group.querySelectorAll('.variant-option').forEach(function (el) {
        el.classList.remove('variant-option--selected');
      });
      var label = e.target.closest('.variant-option');
      if (label) label.classList.add('variant-option--selected');
    });
  });

  /* ── Initial cart count sync ────────────────────────────────── */
  fetchCart().then(function (cart) {
    if (!cart) return;
    cartBadges.forEach(function (el) { el.textContent = cart.item_count; });
    var drawerCount = document.getElementById('cart-drawer-count');
    if (drawerCount) drawerCount.textContent = cart.item_count;
  });
})();
